module.exports = __webpack_public_path__ + "static/media/flask.fcf5d9b4.svg";